import * as React from "react";

import { renderToggleButton_unstable } from "@fluentui/react-components";

import { useRibbonSplitButtonPrimaryToggleButton } from "./useRibbonSplitButtonPrimaryToggleButton";
import { useRibbonSplitButtonPrimaryToggleButtonStyles } from "./useRibbonSplitButtonPrimaryToggleButtonStyles.styles";
import type { RibbonToggleButtonProps } from "../../RibbonToggleButton/next";
import { AppTooltipContainer } from "@1js/acui-tooltip";

export const RibbonSplitButtonPrimaryToggleButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonToggleButtonProps>((props, ref) => {
    const state = useRibbonSplitButtonPrimaryToggleButton(props, ref);

    useRibbonSplitButtonPrimaryToggleButtonStyles(state);

    return (
      <AppTooltipContainer {...props}>
        {renderToggleButton_unstable(state)}
      </AppTooltipContainer>
    );
  })
);

RibbonSplitButtonPrimaryToggleButton.displayName =
  "next/RibbonSplitButtonPrimaryToggleButton";
